// ToggleThemeButton.js
import React, { useContext } from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Brightness4Icon from '@mui/icons-material/Brightness4'
import Brightness7Icon from '@mui/icons-material/Brightness7'
import { useTheme } from '@mui/material/styles'
import { ColorModeContext } from '../../Root'
import { useTranslation } from 'react-i18next'

const ToggleThemeButton = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const colorMode = useContext(ColorModeContext)

  return (
    <Tooltip title={t('webAppearance')}>
      <IconButton onClick={colorMode.toggleColorMode} color="inherit">
        {theme.palette.mode === 'dark' ? (
          <Brightness7Icon />
        ) : (
          <Brightness4Icon />
        )}
      </IconButton>
    </Tooltip>
  )
}

export default ToggleThemeButton
